import DevExpress from 'devextreme';
import { CompareHelper } from 'libs/abc/core';
import { AbcDropDownBoxComponent } from 'libs/abc/ui-components/src/lib/core/src/abc-drop-down-box/abc-drop-down-box.component';
import { AbcCoreComponent } from 'libs/abc/ui-components/src/lib/core/src/abcCoreComponent';
import { AbcCoreContainerService } from 'libs/abc/ui-components/src/lib/core/src/abcCoreContainer.service';

export class _AbcGridColumn implements DevExpress.ui.dxDataGrid.Column {
  allowExporting?: boolean;
  allowGrouping?: boolean;
  autoExpandGroup?: boolean;
  buttons?: (
    | DevExpress.ui.dxDataGrid.DataGridPredefinedColumnButton
    | DevExpress.ui.dxDataGrid.ColumnButton<any, any>
  )[];
  calculateGroupValue?: string | ((rowData: any) => any);
  cellTemplate?:
    | DevExpress.core.template
    | ((
        cellElement: DevExpress.core.ElementWrapper<HTMLElement>,
        cellInfo: DevExpress.ui.dxDataGrid.ColumnCellTemplateData<any, any>
      ) => any);
  columns?: (string | DevExpress.ui.dxDataGrid.Column<any, any>)[];
  editCellTemplate?:
    | DevExpress.core.template
    | ((
        cellElement: DevExpress.core.ElementWrapper<HTMLElement>,
        cellInfo: DevExpress.ui.dxDataGrid.ColumnEditCellTemplateData<any, any>
      ) => any);
  groupCellTemplate?:
    | DevExpress.core.template
    | ((
        cellElement: DevExpress.core.ElementWrapper<HTMLElement>,
        cellInfo: DevExpress.ui.dxDataGrid.ColumnGroupCellTemplateData<any, any>
      ) => any);
  groupIndex?: number;
  headerCellTemplate?:
    | DevExpress.core.template
    | ((
        columnHeader: DevExpress.core.ElementWrapper<HTMLElement>,
        headerInfo: DevExpress.ui.dxDataGrid.ColumnHeaderCellTemplateData<any, any>
      ) => any);
  showWhenGrouped?: boolean;
  type?: DevExpress.ui.dxDataGrid.DataGridCommandColumnType;
  alignment?: DevExpress.common.HorizontalAlignment;
  allowEditing?: boolean;
  allowFiltering?: boolean;
  allowFixing?: boolean;
  allowHeaderFiltering?: boolean;
  allowHiding?: boolean;
  allowReordering?: boolean;
  allowResizing?: boolean;
  allowSearch?: boolean;
  allowSorting?: boolean;
  calculateCellValue?: (rowData: any) => any;
  calculateDisplayValue?: string | ((rowData: any) => any);
  calculateFilterExpression?: (
    filterValue: any,
    selectedFilterOperation: string,
    target: string
  ) => string | Function | any[];
  calculateSortValue?: string | ((rowData: any) => any);
  caption?: string;
  cssClass?: string;
  customizeText?: (cellInfo: DevExpress.ui.dxDataGrid.ColumnCustomizeTextArg) => string;
  dataField?: string;
  dataType?: DevExpress.common.DataType;
  editorOptions?: any;
  encodeHtml?: boolean;
  falseText?: string;
  filterOperations?: string[];
  filterType?: DevExpress.common.charts.FilterType;
  filterValue?: any;
  filterValues?: any[];
  fixed?: boolean;
  fixedPosition?: DevExpress.common.HorizontalEdge;
  formItem?: DevExpress.ui.dxFormSimpleItem;
  format?: DevExpress.ui.Format;
  headerFilter?: DevExpress.ui.dxDataGrid.ColumnHeaderFilter;
  hidingPriority?: number;
  isBand?: boolean;
  lookup?: DevExpress.ui.dxDataGrid.ColumnLookup;
  minWidth?: number;
  name?: string;
  ownerBand?: number;
  renderAsync?: boolean;
  selectedFilterOperation?: DevExpress.common.charts.SelectedFilterOperation;
  setCellValue?: (newData: any, value: any, currentRowData: any) => void | PromiseLike<void>;
  showEditorAlways?: boolean;
  showInColumnChooser?: boolean;
  sortIndex?: number;
  sortOrder?: DevExpress.common.SortOrder;
  sortingMethod?: (value1: any, value2: any) => number;
  trueText?: string;
  validationRules?: (
    | DevExpress.ui.RequiredRule
    | DevExpress.ui.NumericRule
    | DevExpress.ui.RangeRule
    | DevExpress.ui.StringLengthRule
    | DevExpress.ui.CustomRule
    | DevExpress.ui.CompareRule
    | DevExpress.ui.PatternRule
    | DevExpress.ui.EmailRule
    | DevExpress.ui.AsyncRule
  )[];
  visible?: boolean;
  visibleIndex?: number;
  width?: string | number;

  constructor() {}

  public setCustomCellEditor?(
    abcCoreContainerService: AbcCoreContainerService,
    dropDownBoxSetter: (dropDownBox: AbcDropDownBoxComponent, options: any) => Promise<void>
  ) {
    this.editCellTemplate = async (container, options) => {
      const dropdownBox: AbcCoreComponent = abcCoreContainerService.createComponent(null, AbcDropDownBoxComponent);
      await dropDownBoxSetter(<AbcDropDownBoxComponent>dropdownBox.componentRef.instance, options);
      container.append(dropdownBox.domElement);
    };
  }

  public setDisplayTextDataField?(dataField: string): void {
    this.calculateDisplayValue = dataField;
    this.calculateSortValue = dataField;
    this.calculateGroupValue = dataField;
    this.calculateFilterExpression = (filterValue: any, selectFilterOperation: string, target: string) => {
      return [dataField, selectFilterOperation, filterValue];
    };
    let f = this.headerFilter;
    if (!f) {
      f = {};
      this.headerFilter = f;
    }
    let lastDataSource: any;
    let lastFilter: Object;
    let dataItems: any[];
    f.dataSource = (options) => {
      const ds = options.component?.getDataSource();
      const filter = options.component?.getCombinedFilter();
      const arr = ds?.items();
      if (arr) {
        options.dataSource.postProcess = (items) => {
          if (dataItems && lastDataSource === ds && CompareHelper.areDeepEqual(filter, lastFilter)) {
            return dataItems;
          }
          dataItems = [];
          lastDataSource = ds;
          lastFilter = filter;
          for (const orig of items) {
            const item = arr.find((item) => item[this.dataField] == orig.value);
            if (item) {
              dataItems.push({ value: item[dataField], text: item[dataField] });
            }
          }
          return dataItems;
        };
      }
    };
  }
}
